import { bunja } from 'bunja';

import { pswapsAtom } from './internal/fixed-topics/pswaps';
import { r230522SocketBunja } from './socket';

export type * from './internal/fixed-topics/pswaps';

export const pswapsBunja = bunja(() => {
  bunja.use(r230522SocketBunja);
  return { pswapsAtom };
});
pswapsBunja.debugLabel = 'pswapsBunja';
